var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "crud crud-edit" }, [
    _c("form", [
      _c("fieldset", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-3" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.errors.first("gateway"),
                    expression: "errors.first('gateway')",
                  },
                ],
                staticClass: "form-group",
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "gateway", title: _vm.$t("__.obrigatorio") },
                  },
                  [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$t(
                            "__.Crud.configuracaoFranquiaGatewayPagamento.edit_vue_html.gatewayPagamento"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("combo-component", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    id: "gateway",
                    name: "gateway",
                    data: _vm.gatewaysOptions,
                  },
                  model: {
                    value: _vm.gateway,
                    callback: function ($$v) {
                      _vm.gateway = $$v
                    },
                    expression: "gateway",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-8" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass: "control-label",
                  attrs: { for: "linkPagamento" },
                },
                [
                  _vm._v(
                    "\n                            " +
                      _vm._s(
                        _vm.$t(
                          "__.Components.parent.venda.linkPagamento_vue_html.linkPagamento"
                        )
                      ) +
                      "\n                        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.linkPagamento,
                    expression: "linkPagamento",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "linkPagamento",
                  name: "linkPagamento",
                  autocomplete: "off",
                  disabled: "",
                },
                domProps: { value: _vm.linkPagamento },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.linkPagamento = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _vm.linkPagamento.length > 0
            ? _c("div", { staticClass: "col-sm-1 input-with-icon" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", {
                    staticClass: "control-label",
                    attrs: { for: "detalhesTaxaEntrega" },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "input-group-addon form-control input-with-icon-wrapper",
                      attrs: {
                        title: _vm.$t(
                          "__.Components.parent.venda.linkPagamento_vue_html.copiarAreaTransf"
                        ),
                      },
                      on: { click: _vm.copiarTexto },
                    },
                    [_c("span", { staticClass: "fas fa-copy" })]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-12 newbtn" }, [
              _c(
                "button",
                {
                  staticClass: "btn btnCopiar",
                  attrs: { type: "button" },
                  on: { click: _vm.criarLinkPagamento },
                },
                [
                  _vm._v(
                    "\n                            " +
                      _vm._s(
                        _vm.$t(
                          "__.Components.parent.venda.linkPagamento_vue_html.gerarLink"
                        )
                      ) +
                      "\n                        "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }